module.exports = __webpack_public_path__ + "img/balancer_logo.48864639.svg";